import { createReducer } from '../utils';
import { GET_EXTERNAL_EVIDENCE_START, GET_EXTERNAL_EVIDENCE_DONE, GET_EXTERNAL_EVIDENCE_ERROR } from '../actions';

const initialState = {
    loading: false,
    data: null,
    error: null
};

export default createReducer(initialState, {
    [GET_EXTERNAL_EVIDENCE_START]: (state) => {
        return Object.assign({}, state, {
            loading: true
        });
    },
    [GET_EXTERNAL_EVIDENCE_DONE]: (state, payload) => {
        return Object.assign({}, state, {
            loading: false,
            data: payload.data
        });
    },
    [GET_EXTERNAL_EVIDENCE_ERROR]: (state, payload) => {
        return Object.assign({}, state, {
            loading: false,
            error: payload.data
        });
    }
});
